import { render, staticRenderFns } from "./DepositTable.vue?vue&type=template&id=3fbfd0cc&scoped=true"
import script from "./DepositTable.vue?vue&type=script&lang=js"
export * from "./DepositTable.vue?vue&type=script&lang=js"
import style0 from "./DepositTable.vue?vue&type=style&index=0&id=3fbfd0cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbfd0cc",
  null
  
)

export default component.exports